import { render, staticRenderFns } from "./ModalItemIframe.vue?vue&type=template&id=19ac8ab4&scoped=true&"
import script from "./ModalItemIframe.vue?vue&type=script&lang=ts&"
export * from "./ModalItemIframe.vue?vue&type=script&lang=ts&"
import style0 from "./ModalItemIframe.vue?vue&type=style&index=0&id=19ac8ab4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ac8ab4",
  null
  
)

export default component.exports